export default "__VITE_PUBLIC_ASSET__087a64f7__"